// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container_c8iqa{position:fixed;visibility:hidden;transition-property:visibility;touch-action:pan-y;z-index:900}.container_c8iqa,.scrim_TC05W{top:0;bottom:0;right:0;left:0}.scrim_TC05W{transition-property:opacity;transform:translateZ(0);opacity:0;background:rgba(0,0,0,.5)}.content_\\+DyTO,.scrim_TC05W{position:absolute}.content_\\+DyTO{top:0;bottom:0;left:0;width:256px;transition-property:transform;transform:translate3d(-100%,0,0);background-color:#fff}", ""]);
// Exports
exports.locals = {
	"container": "container_c8iqa",
	"scrim": "scrim_TC05W",
	"content": "content_+DyTO"
};
module.exports = exports;
